// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MRiS","title":"styles_title__3OWgB"};